var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m20.4 19.5-15-15m4.8 5.942c-.373.411-.6.952-.6 1.544 0 1.29 1.075 2.336 2.4 2.336.611 0 1.169-.223 1.593-.589m6.846.589c.826-1.237 1.161-2.246 1.161-2.246S19.415 5.1 12 5.1c-.416 0-.816.022-1.2.063m6.6 12.186c-1.377.88-3.15 1.5-5.4 1.464-7.323-.12-9.6-6.737-9.6-6.737s1.058-3.378 4.2-5.433"
  })));
};
export default SvgEyeClosed;